import { render } from "./Extend.vue?vue&type=template&id=65c0bc46&scoped=true"
import script from "./Extend.vue?vue&type=script&lang=js"
export * from "./Extend.vue?vue&type=script&lang=js"

import "./Extend.vue?vue&type=style&index=0&id=65c0bc46&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c0bc46"]])

export default __exports__